module.exports = __webpack_public_path__ + "static/media/BunburyHerald-devicecomp-min.6dbf4b7a.webp";